import Footer from "components/mobile-view/footer";
import React from "react";

const MobileApplicationNavigationBar = () => {
  return <Footer />;
};

export default MobileApplicationNavigationBar;
